import axiosClient from '../axiosClient';

export const getCoinStats = () =>
  axiosClient.get('/admin/coins/stats');

export const adjustUserCoins = (data) =>
  axiosClient.post('/admin/coins/adjust', data);

export const updateCoinSettings = (data) =>
  axiosClient.put('/admin/coins/settings', data);

export const getCoinPacks = () =>
  axiosClient.get('/admin/coins/packs');

export const createCoinPack = (data) =>
  axiosClient.post('/admin/coins/packs', data);

export const updateCoinPack = (id, data) =>
  axiosClient.put('/admin/coins/packs/' + id, data);

export const deleteCoinPack = (id) =>
  axiosClient.delete('/admin/coins/packs/' + id);
